module.exports = __webpack_public_path__ + "img/bitmovin.e575cdd1.png";